import { TLocale } from '@internal/utils/machine/i18n/Locale'

const COUNTRY_COORDS = [
  // {
  //   locale: 'en',
  //   lat: 51.5072,
  //   lng: 0.1276,
  //   city: 'London',
  // },
  {
    locale: 'en',
    lat: 52.81806370599271,
    lng: -5.308706653275761,
    city: 'Between England and Ireland',
  },
  {
    locale: 'de',
    lat: 48.1351,
    lng: 11.582,
    city: 'Munich',
  },
  {
    locale: 'bg',
    lat: 42.6977,
    lng: 23.3219,
    city: 'Sofia',
  },
  {
    locale: 'fr',
    lat: 48.8566,
    lng: 2.3522,
    city: 'Paris',
  },
  {
    locale: 'el',
    lat: 37.9838,
    lng: 23.7275,
    city: 'Athens',
  },
  {
    locale: 'it',
    lat: 41.9028,
    lng: 12.4964,
    city: 'Rome',
  },
  {
    locale: 'pl',
    lat: 52.2297,
    lng: 21.0122,
    city: 'Warsaw',
  },
  {
    locale: 'ro',
    lat: 44.4268,
    lng: 26.1025,
    city: 'Bucharest',
  },
  {
    locale: 'ru',
    lat: 55.7558,
    lng: 37.6173,
    city: 'Moscow',
  },
  {
    locale: 'hu',
    lat: 47.4979,
    lng: 19.0402,
    city: 'Budapest',
  },
  {
    locale: 'es',
    lat: 40.4168,
    lng: 3.7038,
    city: 'Madrid',
  },
  {
    locale: 'sl',
    lat: 46.0569,
    lng: 14.5058,
    city: 'Ljubljana',
  },
  {
    locale: 'sr',
    lat: 44.8125,
    lng: 20.4612,
    city: 'Belgrade',
  },
  {
    locale: 'da',
    lat: 55.6761,
    lng: 12.5683,
    city: 'Copenhagen',
  },
  {
    locale: 'cs',
    lat: 50.0755,
    lng: 14.4378,
    city: 'Prague',
  },
  {
    locale: 'lt',
    lat: 54.6872,
    lng: 25.2787,
    city: 'Vilnius',
  },
]

export type LocationProps = {
  lat: number
  lng: number
  city: string
}

export const getGeoLocation = (suppliedLocale: TLocale): LocationProps => {
  try {
    if (!suppliedLocale) {
      return COUNTRY_COORDS.filter(({ locale }) => locale === 'de')[0]
    }

    return COUNTRY_COORDS.filter(({ locale }) => locale === suppliedLocale)[0]
  } catch (err) {
    console.error({ 'Error retriving geo location': err })
    return COUNTRY_COORDS.filter(({ locale }) => locale === 'de')[0]
  }
}
